/* 
    Functions used for product card functionalities, such as variant switching 
    and displaying the product description properly. 
*/

/* Product Card Functions */

/* Adjusts description bottom value so that it does not go beyond the top of the product image */
function adjustDescriptionPosition(figure) {
    const description = figure.querySelector('.description');
    const figureHeight = figure.clientHeight;
    const descriptionHeight = description.clientHeight;

    // Do not animate product description on hover when it is blank
    const descriptionOverlay = description.querySelector('.overlay');
    if (!descriptionOverlay || descriptionOverlay.textContent.trim() === "" || descriptionOverlay.innerHTML.trim() === "") {
        return;
    }
    
    if (descriptionHeight > figureHeight) {
      // Limit the description's bottom movement to prevent it from going beyond the top
      const maxBottom = figureHeight - descriptionHeight;
      description.style.bottom = `${maxBottom}px`;
    } else {
      // Keep the description aligned to the bottom
      description.style.bottom = '0';
    }
}

// Resets description bottom value so that the animation can trigger properly
function resetDescriptionPosition(figure) {
    const description = figure.querySelector('.description');

    // Unset the inline style to allow the animation to work again
    description.style.bottom = '';
}

/* 
    Triggering the description positionment functions.
*/

function initProductDescriptions() {
    document.querySelectorAll('.product-card figure').forEach(figure => {
        // Make the figure focusable by adding tabindex
        figure.setAttribute('tabindex', '0');

        // Trigger adjustment when hover starts
        figure.addEventListener('mouseenter', function() {
            adjustDescriptionPosition(figure);
        });

        // Trigger reset when mouse leaves the figure
        figure.addEventListener('mouseleave', function() {
            resetDescriptionPosition(figure);
        });

        // Trigger adjustment when hover starts
        figure.addEventListener('focusin', function() {
            adjustDescriptionPosition(figure);
        });

        // Trigger reset when mouse leaves the figure
        figure.addEventListener('focusout', function() {
            resetDescriptionPosition(figure);
        });
      
        // Reset on window resize, in case of dynamic layout changes
        window.addEventListener('resize', function() {
            resetDescriptionPosition(figure);
        });
    });

    // Prevents activating the link when clicking the details button.
    document.querySelectorAll('.product-card .details').forEach(el => {
        el.addEventListener('click', function(event) {
            // Stop event from propagating to the parent elements
            event.stopPropagation();
        });
    });
}

// Initialize product description positioning logic
document.addEventListener("DOMContentLoaded", function () {
    initProductDescriptions();
});

// Re-init product description logic when selecting different filters.
document.addEventListener('facetChange', function() {
    const productGrid = document.querySelector('.product-grid-container');
    const observer = new MutationObserver(function(mutationsList, observer) {
        // Re-init product description logic after the DOM changes
        initProductDescriptions();
        observer.disconnect(); 
    });

    // Start observing for changes in the product grid's child elements
    observer.observe(productGrid, { childList: true, subtree: true });
});
  

/* Product Variant Functions */

// Changes the product DOM element's properties based on the newly selected variant.
function setProductCurrentVariant(el, locale) {
    // Setting locale prefix to handle multilingual product handles
    let localePrefix = '';

    // Set locale prefix based on the current locale
    if (locale === 'en') {
        localePrefix = '/' + locale; // e.g., '/en'
    }

    // Construct the fetch URL
    const fetchUrl = localePrefix + '/products/' + el.dataset.productHandle + '.js';
    
    // Fetches product information
    fetch(fetchUrl)
    .then(response => {
        if (!response.ok) {
            throw new Error('Product not found or there was an error fetching the product data.');
        }
        return response.json();
    })
    .then(productData => {  
        if (productData.variants && productData.variants.length > 0) {
            findSelectedVariant(el.dataset.productHandle, productData.variants);
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

// Finds the currently selected variant based on the currently selected options.
function findSelectedVariant(handle, variants) {
    // Find the relevant product card 
    // NOTE: using section as a selector to differentiate from the variant selectors 
    // which also have data-product-handle.
    const productElement = document.querySelector("section[data-product-handle='" + handle + "']");
    const productAddToCartButton = productElement.querySelector("form button[type='submit']");

    // Get selected color input and its associated option (e.g., option1 or option2)
    const currentColor = document.querySelector("input[name='color-" + handle + "']:checked");
    const colorOption = currentColor ? currentColor.dataset.option : null;

    // Get selected value from select and its associated option (e.g., option1 or option2)
    const currentSelection = document.querySelector("select[name='select-" + handle + "']");
    const selectOption = currentSelection ? currentSelection.dataset.option : null;

    if (colorOption || selectOption) {
        // Loop through the variants to find a match dynamically based on the dataset.option
        const matchedVariant = variants.find(variant => {
            if (colorOption && selectOption) {
                // Match both color and select
                return variant[colorOption] === currentColor.value && variant[selectOption] === currentSelection.value;
            } else if (colorOption) {
                // Match only color
                return variant[colorOption] === currentColor.value;
            } else if (selectOption) {
                // Match only select
                return variant[selectOption] === currentSelection.value;
            }
        });
    
        if (matchedVariant) {
            // Set product's variant ID to matched ID, for add to cart purposes.
            productElement.querySelector("product-form input[name='id']").value = matchedVariant.id;
            setProductVariantImage(matchedVariant, productElement);

            // If matched variant is active and has items in inventory
            if (matchedVariant.available === true) {
                // Enable add to cart button
                productAddToCartButton.disabled = false;

                // cartTranslations is defined in main-collection-product-grid.liquid
                productAddToCartButton.querySelector('span').innerHTML = cartTranslations['add_to_cart'];
            } else {
                // Disable add to cart button
                productAddToCartButton.disabled = true;

                // cartTranslations is defined in main-collection-product-grid.liquid
                productAddToCartButton.querySelector('span').innerHTML = cartTranslations['sold_out'];
            }
        } else {
            console.error('No matching variant found.');
        }
    } else {
        console.error("Neither color nor select options are present.");
    }
}

// Updates variant image if current variant has an image.
function setProductVariantImage(matchedVariant, productElement) {
    const imageSrc = matchedVariant.featured_image.src;

    if (imageSrc) {
        // Product list and product single main image
        const imageElements = productElement.querySelectorAll(".featured-media > img");

        // Product single first mobile slider modal image
        const sliderMedia = document.querySelector(".product-media-modal__content .product__media-item--variant");

        imageElements.forEach(el => {
            el.src = imageSrc;
            el.srcset = imageSrc;
        });

        if (sliderMedia) {
            sliderMedia.src = imageSrc;
            sliderMedia.srcset = imageSrc;
        }
    }
}